export const keyboardLayouts = {
  'Keychron K6': {
    layout: [
      [
        {width: 1, key: 'ESC'}, {width: 1, key: '1'}, {width: 1, key: '2'}, {width: 1, key: '3'}, {width: 1, key: '4'},
        {width: 1, key: '5'}, {width: 1, key: '6'}, {width: 1, key: '7'}, {width: 1, key: '8'}, {width: 1, key: '9'},
        {width: 1, key: '0'}, {width: 1, key: '-'}, {width: 1, key: '='}, {width: 2, key: 'BACKSPACE'}, {width: 1, key: 'DEL'}
      ],
      [
        {width: 1.5, key: 'TAB'}, {width: 1, key: 'Q'}, {width: 1, key: 'W'}, {width: 1, key: 'E'}, {width: 1, key: 'R'},
        {width: 1, key: 'T'}, {width: 1, key: 'Y'}, {width: 1, key: 'U'}, {width: 1, key: 'I'}, {width: 1, key: 'O'},
        {width: 1, key: 'P'}, {width: 1, key: '['}, {width: 1, key: ']'}, {width: 1.5, key: '\\'}, {width: 1, key: 'HOME'}
      ],
      [
        {width: 1.75, key: 'CAPS'}, {width: 1, key: 'A'}, {width: 1, key: 'S'}, {width: 1, key: 'D'}, {width: 1, key: 'F'},
        {width: 1, key: 'G'}, {width: 1, key: 'H'}, {width: 1, key: 'J'}, {width: 1, key: 'K'}, {width: 1, key: 'L'},
        {width: 1, key: ';'}, {width: 1, key: "'"}, {width: 2.25, key: 'ENTER'}, {width: 1, key: 'PGUP'}
      ],
      [
        {width: 2.25, key: 'SHIFT'}, {width: 1, key: 'Z'}, {width: 1, key: 'X'}, {width: 1, key: 'C'}, {width: 1, key: 'V'},
        {width: 1, key: 'B'}, {width: 1, key: 'N'}, {width: 1, key: 'M'}, {width: 1, key: ','}, {width: 1, key: '.'},
        {width: 1, key: '/'}, {width: 1.75, key: 'SHIFT'}, {width: 1, key: '↑'}, {width: 1, key: 'PGDN'}
      ],
      [
        {width: 1.25, key: 'CTRL'}, {width: 1.25, key: 'WIN'}, {width: 1.25, key: 'ALT'}, {width: 6.25, key: 'SPACE'},
        {width: 1, key: 'ALT'}, {width: 1, key: 'FN'}, {width: 1, key: 'CTRL'}, {width: 1, key: '←'},
        {width: 1, key: '↓'}, {width: 1, key: '→'}
      ]
    ]
  },
  'Keychron K8': {
    layout: [
      // Row 1
      [
        {width: 1, key: 'ESC'},
        {width: 1, key: ''},
        {width: 1, key: 'F1'}, {width: 1, key: 'F2'}, {width: 1, key: 'F3'}, {width: 1, key: 'F4'},
        {width: 0.5, key: ''},
        {width: 1, key: 'F5'}, {width: 1, key: 'F6'}, {width: 1, key: 'F7'}, {width: 1, key: 'F8'},
        {width: 0.5, key: ''},
        {width: 1, key: 'F9'}, {width: 1, key: 'F10'}, {width: 1, key: 'F11'}, {width: 1, key: 'F12'},
        {width: 0.25, key: ''},
        {width: 1, key: 'PrtSc'}, {width: 1, key: 'ScrLk'}, {width: 1, key: 'Pause'}
      ],
      // Row 2
      [
        {width: 1, key: '`'}, {width: 1, key: '1'}, {width: 1, key: '2'}, {width: 1, key: '3'}, {width: 1, key: '4'},
        {width: 1, key: '5'}, {width: 1, key: '6'}, {width: 1, key: '7'}, {width: 1, key: '8'}, {width: 1, key: '9'},
        {width: 1, key: '0'}, {width: 1, key: '-'}, {width: 1, key: '='}, {width: 2, key: 'Backspace'},
        {width: 0.25, key: ''},
        {width: 1, key: 'Ins'}, {width: 1, key: 'Home'}, {width: 1, key: 'PgUp'}
      ],
      // Row 3
      [
        {width: 1.5, key: 'Tab'}, {width: 1, key: 'Q'}, {width: 1, key: 'W'}, {width: 1, key: 'E'}, {width: 1, key: 'R'},
        {width: 1, key: 'T'}, {width: 1, key: 'Y'}, {width: 1, key: 'U'}, {width: 1, key: 'I'}, {width: 1, key: 'O'},
        {width: 1, key: 'P'}, {width: 1, key: '['}, {width: 1, key: ']'}, {width: 1.5, key: '\\'},
        {width: 0.25, key: ''},
        {width: 1, key: 'Del'}, {width: 1, key: 'End'}, {width: 1, key: 'PgDn'}
      ],
      // Row 4
      [
        {width: 1.75, key: 'Caps'}, {width: 1, key: 'A'}, {width: 1, key: 'S'}, {width: 1, key: 'D'}, {width: 1, key: 'F'},
        {width: 1, key: 'G'}, {width: 1, key: 'H'}, {width: 1, key: 'J'}, {width: 1, key: 'K'}, {width: 1, key: 'L'},
        {width: 1, key: ';'}, {width: 1, key: "'"}, {width: 2.25, key: 'Enter'},
        {width: 3.25, key: ''}
      ],
      // Row 5
      [
        {width: 2.25, key: 'Shift'}, {width: 1, key: 'Z'}, {width: 1, key: 'X'}, {width: 1, key: 'C'}, {width: 1, key: 'V'},
        {width: 1, key: 'B'}, {width: 1, key: 'N'}, {width: 1, key: 'M'}, {width: 1, key: ','}, {width: 1, key: '.'},
        {width: 1, key: '/'}, {width: 2.75, key: 'Shift'},
        {width: 1.25, key: ''}, {width: 1, key: '↑'}, {width: 1.25, key: ''}
      ],
      // Row 6
      [
        {width: 1.25, key: 'Ctrl'}, {width: 1.25, key: 'Win'}, {width: 1.25, key: 'Alt'}, 
        {width: 6.25, key: 'Space'},
        {width: 1.25, key: 'Alt'}, {width: 1.25, key: 'Option'}, {width: 1.25, key: 'Ctrl'}, {width: 1.25, key: 'Fn'},
        {width: 0.25, key: ''}, {width: 1, key: '←'}, {width: 1, key: '↓'}, {width: 1, key: '→'}
      ]
    ]
  }
};